
import axios from "axios";
import { toast } from "react-toastify";
import { history } from "../index";
import LocalStorageService from "./../shared/services/localStorageService";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Language } from "@mui/icons-material";
// import { getErrorMessages } from "./../shared/utils/utility";
const localStorageService = new LocalStorageService();
//axios.defaults.baseURL = "https://testapi.rentgo.com/api";
axios.defaults.baseURL = process.env.REACT_APP_API_URL + "/api"; // "https://prod-api.rentgo.com/api"


// "http://localhost:8090/api";
// axios.defaults.baseURL = "https://localhost:5001/api";
 //axios.defaults.baseURL = 'https://localhost:44336/api';
axios.interceptors.request.use(undefined, (error) => {
  return Promise.reject(error);
});
axios.interceptors.response.use(undefined, (error) => {
 console.log(error,"errrrr");
  if (error) {
    if (error.response) {
      const { status } = error.response;
     // logoutUser();
      if (error.message === "Network Error" && !error.response)
        toast.error("Ağ hatası, servise erişilemiyor.");
      else if (status === 401) {
        toast.error("Yetki Hatası");
        logoutUser();
      } else if (status === 404) {
        toast.error("404"); //history.push("/notfound");
      } else if (status === 511) {
        logoutUser();
        //localStorageService.logout();
        goLoginPage();
      } else {
        toast.error("Hata Oluştu: ");
        console.log(error,"ERR-YSN")
      }
    } else {
      toast.error("Beklenmeyen Bir Hata Oluştu.");
    }
    throw error;
  }
});

const goLoginPage = () => {
  window.location = "#/login";
};
const responseBody = (response) => {

  return response && response.data;
};
const sleep = (ms) => (response) =>
  new Promise((resolve) => setTimeout(() => resolve(response), ms));

const requests = {

  get: (url,lang) =>
    axios
      .get(url,{
        headers: {
          //  Authorization: `Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImN0eSI6IkpXVCJ9.eyJpYXQiOjE2NzA4NDU3OTMsIlVzZXJJZCI6IjYiLCJFbWFpbCI6ImNuckB0Y20uY29tLnRyIiwiVXNlck1lbnVzIjoiWzEsMiwzLDYsNyw4LDksMTAsMTIsMTMsMTYsMTcsMTgsMTksMjAsMjEsMjIsMjMsMjQsMjUsMjYsMjddIiwiVXNlckluZm8iOiJ7XCJJZFwiOjYsXCJOYW1lXCI6XCJHw7Z6ZGVcIixcIlN1cm5hbWVcIjpcIkFsdMSxbmRpxZ9cIixcIkVtYWlsXCI6XCJjbnJAdGNtLmNvbS50clwiLFwiVXNlck1lbnVzXCI6WzEsMiwzLDYsNyw4LDksMTAsMTIsMTMsMTYsMTcsMTgsMTksMjAsMjEsMjIsMjMsMjQsMjUsMjYsMjddLFwiVXNlclJvbGVzXCI6W1wiQWRtaW5cIixcIlVzZXJcIl0sXCJMYW5ndWFnZUlkXCI6NH0iLCJuYmYiOjE2NzA4NDU3OTMsImV4cCI6MTY3MTEwNDk5MywiaXNzIjoiSXNzIiwiYXVkIjoiQXVkIn0.UQAj6gm474Bri15QKnnp90xu8pm2Hs4EWMXzPg3kPyJfis1otvzJxKOCCwJT0zah4nGCzf2ozVihIBTl8GmgiMAvDuUum6hSrwvq5QlEuDrvV2KhkIdHdw84gCUVUbv-wNfZEU7fPibcGZ-4bAla4_qgO6IX4SyCOY1MG_MQuQtS-6lypLSoExIVDDY_9gXvHHlxLJdh-FslCOxw3hGy_WNtWF_W98h4Axeu4KSE4I0-wDcRBu4P5XeFLkfQhlC_nrwPjTV6_BcwBXt1pfCEykPdynet9gpNGVxTwNQxuvGprlB_E_eoowxHsBHwD0b0ATB24u5C8jo5IfwQMVithA`},
          Authorization: `${new LocalStorageService().authData.token}`,
             'Accept-Language': lang==1033?"en-US":"tr-TR"
        },
      })
      //.then(sleep(2000))
      .then(responseBody),
  post: (url, body,lang) =>
  {
   
    return    axios
      .post(url, body, {
       headers: {
          Authorization: `${new LocalStorageService().authData.token}`,
          'Accept-Language': lang==1033?"en-US":"tr-TR"
      },
      })
      //.then(sleep(1000))
      .then(responseBody)
    },
      postMulti: (url, body) =>
      axios
        .post(url, body, {
         headers: {
            Authorization: `${new LocalStorageService().authData.token}`,
          'content-type': 'multipart/form-data'
        //  "puserId":"12" 
        },
        })
        //.then(sleep(1000))
        .then(responseBody),
      
  put: (url, body) =>
    axios
      .put(url, body, {
        headers: {
          //  Authorization: `Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImN0eSI6IkpXVCJ9.eyJpYXQiOjE2NzA4NDU3OTMsIlVzZXJJZCI6IjYiLCJFbWFpbCI6ImNuckB0Y20uY29tLnRyIiwiVXNlck1lbnVzIjoiWzEsMiwzLDYsNyw4LDksMTAsMTIsMTMsMTYsMTcsMTgsMTksMjAsMjEsMjIsMjMsMjQsMjUsMjYsMjddIiwiVXNlckluZm8iOiJ7XCJJZFwiOjYsXCJOYW1lXCI6XCJHw7Z6ZGVcIixcIlN1cm5hbWVcIjpcIkFsdMSxbmRpxZ9cIixcIkVtYWlsXCI6XCJjbnJAdGNtLmNvbS50clwiLFwiVXNlck1lbnVzXCI6WzEsMiwzLDYsNyw4LDksMTAsMTIsMTMsMTYsMTcsMTgsMTksMjAsMjEsMjIsMjMsMjQsMjUsMjYsMjddLFwiVXNlclJvbGVzXCI6W1wiQWRtaW5cIixcIlVzZXJcIl0sXCJMYW5ndWFnZUlkXCI6NH0iLCJuYmYiOjE2NzA4NDU3OTMsImV4cCI6MTY3MTEwNDk5MywiaXNzIjoiSXNzIiwiYXVkIjoiQXVkIn0.UQAj6gm474Bri15QKnnp90xu8pm2Hs4EWMXzPg3kPyJfis1otvzJxKOCCwJT0zah4nGCzf2ozVihIBTl8GmgiMAvDuUum6hSrwvq5QlEuDrvV2KhkIdHdw84gCUVUbv-wNfZEU7fPibcGZ-4bAla4_qgO6IX4SyCOY1MG_MQuQtS-6lypLSoExIVDDY_9gXvHHlxLJdh-FslCOxw3hGy_WNtWF_W98h4Axeu4KSE4I0-wDcRBu4P5XeFLkfQhlC_nrwPjTV6_BcwBXt1pfCEykPdynet9gpNGVxTwNQxuvGprlB_E_eoowxHsBHwD0b0ATB24u5C8jo5IfwQMVithA`},
          Authorization: `${new LocalStorageService().authData.token}`
        },
      })
      //.then(sleep(1000))
      .then(responseBody),
  delete: (url) =>
    axios
      .delete(url, {
        headers: { Authorization: `Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImN0eSI6IkpXVCJ9.eyJpYXQiOjE2NzA4NDU3OTMsIlVzZXJJZCI6IjYiLCJFbWFpbCI6ImNuckB0Y20uY29tLnRyIiwiVXNlck1lbnVzIjoiWzEsMiwzLDYsNyw4LDksMTAsMTIsMTMsMTYsMTcsMTgsMTksMjAsMjEsMjIsMjMsMjQsMjUsMjYsMjddIiwiVXNlckluZm8iOiJ7XCJJZFwiOjYsXCJOYW1lXCI6XCJHw7Z6ZGVcIixcIlN1cm5hbWVcIjpcIkFsdMSxbmRpxZ9cIixcIkVtYWlsXCI6XCJjbnJAdGNtLmNvbS50clwiLFwiVXNlck1lbnVzXCI6WzEsMiwzLDYsNyw4LDksMTAsMTIsMTMsMTYsMTcsMTgsMTksMjAsMjEsMjIsMjMsMjQsMjUsMjYsMjddLFwiVXNlclJvbGVzXCI6W1wiQWRtaW5cIixcIlVzZXJcIl0sXCJMYW5ndWFnZUlkXCI6NH0iLCJuYmYiOjE2NzA4NDU3OTMsImV4cCI6MTY3MTEwNDk5MywiaXNzIjoiSXNzIiwiYXVkIjoiQXVkIn0.UQAj6gm474Bri15QKnnp90xu8pm2Hs4EWMXzPg3kPyJfis1otvzJxKOCCwJT0zah4nGCzf2ozVihIBTl8GmgiMAvDuUum6hSrwvq5QlEuDrvV2KhkIdHdw84gCUVUbv-wNfZEU7fPibcGZ-4bAla4_qgO6IX4SyCOY1MG_MQuQtS-6lypLSoExIVDDY_9gXvHHlxLJdh-FslCOxw3hGy_WNtWF_W98h4Axeu4KSE4I0-wDcRBu4P5XeFLkfQhlC_nrwPjTV6_BcwBXt1pfCEykPdynet9gpNGVxTwNQxuvGprlB_E_eoowxHsBHwD0b0ATB24u5C8jo5IfwQMVithA` },
      })
      //.then(sleep(1000))
      .then(responseBody),
};
const logoutUser = async () => {
  // new LocalStorageService().logout();
  await AsyncStorage.removeItem("authdata");
   //navigate("/login", { replace: true });
  window.location = "/login";
 
};
export default {
  requests,
};
